<script setup lang="ts">
import Modal from "@/ui/components/modal.vue";
import { useApiClient } from "@/api/client";
import { ref, onMounted } from "vue";
import RentableTypeAssetDO = Modules.BookingExperts.Data.RentableTypeAssetDO;

const client = useApiClient("bookingExperts");
const visible = defineModel<boolean>();
const loading = ref(false);
const rentableTypes = ref<RentableTypeAssetDO[]>([]);

const { rentableTypeIds, rentableTypeAssets, pricelistName } = defineProps<{
	rentableTypeIds?: number[];
	rentableTypeAssets?: RentableTypeAssetDO[];
	pricelistName: string;
}>();

onMounted(async () => {
	loading.value = true;

	if (rentableTypeAssets) {
		rentableTypes.value = rentableTypeAssets;
	} else {
		const response = await client.getRentableTypeDisplayNames(rentableTypeIds);
		if (response.isOk()) {
			rentableTypes.value = response.value;
		}
	}
	loading.value = false;
});
</script>

<template>
	<Modal
		v-model:visible="visible"
		:title="`Used types in ${pricelistName}`"
		icon="fa-solid fa-circle-info"
		width="35rem"
		hide-actions
	>
		<div v-if="loading" class="d-flex justify-center pa-4">
			<v-progress-circular indeterminate color="primary" />
		</div>

		<template v-else>
			<p
				v-if="rentableTypes.length === 0"
				class="text-medium-emphasis text-body-2"
			>
				No rentable types linked to this price list.
			</p>

			<v-list v-else density="compact" class="bg-transparent pa-0">
				<v-list-item
					v-for="type in rentableTypes"
					:key="type.id"
					:title="type.display_name"
				>
					<template #prepend>
						<v-icon
							icon="fa-solid fa-circle"
							size="6"
							color="medium-emphasis"
						/>
					</template>
				</v-list-item>
			</v-list>
		</template>
	</Modal>
</template>

<style scoped lang="scss"></style>
